<template>
  <Loading v-if="!fullyLoaded" />
  <UserForm v-else :submit="submit" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/users_service';
import UserRoleService from '@/services/resources/user_roles_service';

const NEW_USER_ROLE = 2;

export default {
  mixins: [CreateView],
  components: {
    UserForm: () => import('@/components/forms/UserForm.vue'),
  },
  data() {
    return {
      urlFragment: 'users',
      resourceService: ResourceService,
    };
  },
  methods: {
    submit(user) {
      return ResourceService.create(user)
        .then(async (result) => {
          if (this.$route.params.site_id) {
            await UserRoleService.create({
              role: {
                id: NEW_USER_ROLE,
                type: 'roles',
              },
              group: {
                type: 'sites',
                id: this.$route.params.site_id,
              },
              user: {
                type: 'users',
                id: result.data.id,
              },
            });
          }
          this.successToast(`Created ${result.data.email}`);
          this.$router.push(this.destination);
        })
        .catch(this.failToast);
    },
  },
};
</script>
